import axios from "axios";
import { global } from "@shared/libs/Global";

/**
 * 목적: AI 회의록 화면 전용 API 경로 · 음성 업로드.
 *
 * 배경:
 * 조회/저장은 공통 fnGetDataSet/fnSave 를, 전사 · 회의록 생성은 화면이 공통 apiPost(오류창 포함)로 부른다.
 * 전사 · 회의록 생성은 BE 가 AI 중앙(/meeting/*)에 맡긴다(2026-10-22). 전사는 저장소에 올라간 음성의
 * 경로(dc_url)로 부른다 — 예전에는 저장된 음성을 내려받아 다시 올렸다.
 */

/** 전사 — multipart dc_url(또는 file) · language → { dc_stt } */
export const MEETING_TRANSCRIBE_URL = "/SN_SFA_MEETING_REG_001_TRANSCRIBE_01";

/** AI 회의록 생성 — { dc_stt, nm_meeting, dt_meeting, fg_meeting, nm_cust, js_participant } → { dc_minutes } */
export const MEETING_MINUTES_URL = "/SN_SFA_MEETING_REG_001_MINUTES_01";

/**
 * 전사 진행 — { id_request } → { stage: "SPLIT" | "TRANSCRIBE" | null, total?, done? } (2026-10-22).
 * 전사를 보낼 때 실은 id_request 로 묻는다. total · done 은 받아쓰는 중일 때 끝난 조각 / 전체 조각
 */
export const MEETING_PROGRESS_URL = "/SN_SFA_MEETING_REG_001_PROGRESS_01";

export interface UploadedAudio {
  nm_file: string;
  dc_url: string;
}

/**
 * 음성 파일을 서버 저장소에 업로드하고 저장 경로(dc_url)를 받는다.
 * 기존 첨부 공통 업로드(/file/upload2)를 재사용한다. 응답이 ApiResponse 봉투가 아닌 원시 배열이라 axios로 호출한다.
 *
 * @param file 업로드할 음성 File
 * @param filePath 저장 폴더 경로(예: SN_SFA_MEETING_REG_001/2026060010)
 * @param onProgress 올린 비율(0~100). 화면이 진행률을 보여 줄 때
 */
export async function fnUploadMeetingAudio(
  file: File,
  filePath: string,
  onProgress?: (percent: number) => void
): Promise<UploadedAudio | null> {
  const formData = new FormData();
  formData.append("files", file);
  formData.append("filePath", filePath);

  const res = await axios.post("/snotes/file/upload2", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
    },
    onUploadProgress: (event) => {
      if (onProgress && event.total) {
        onProgress(Math.min(100, Math.round((event.loaded / event.total) * 100)));
      }
    },
  });

  const list = res.data;
  const saved = Array.isArray(list) ? list[0] : null;
  if (!saved || !saved.dc_url) return null;
  return { nm_file: saved.nm_file, dc_url: saved.dc_url };
}
